import React, {createContext, useContext} from 'react';
import useWeb3 from 'features/web3/hooks/useWeb3';

export const MetamaskContext = createContext();

const EtheloWeb3Provider = ({ children }) => {
  const state = useWeb3();

  return (
    <MetamaskContext.Provider value={state}>
      {children}
    </MetamaskContext.Provider>
  );
};


const useWeb3Context = () => {
  const metamaskContext = useContext(MetamaskContext);
  if (!metamaskContext) {
    throw new Error('useWeb3Provider must be used within a PinProvider');
  }
  return metamaskContext;
};

export { EtheloWeb3Provider, useWeb3Context };
